export default function SocialLink({ link }) {
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex items-center justify-center w-12 h-12 rounded-full bg-emerald-600/20 border border-emerald-400/30 hover:bg-emerald-500/30 hover:border-emerald-400/50 transition-all duration-300 hover:scale-110"
      aria-label={link.label}
    >
      <div className="w-6 h-6 text-emerald-300 group-hover:text-emerald-200 transition-colors duration-300">
        {link.icon}
      </div>
    </a>
  );
}